import {
    EntityId,
    LogChannel,
    LogRole,
    LogUser,
} from "../types.js";
import {
    DefaultHttpClient,
    HttpClient,
} from "./HttpClient.js";

export class EntityClient {
    readonly http: HttpClient;

    constructor({ http = DefaultHttpClient }: { http?: HttpClient } = {}) {
        this.http = http;
    }

    getRoles(signal?: AbortSignal): Promise<LogRole[]> {
        return this.http.json("/api/roles", { signal });
    }

    getChannels(signal?: AbortSignal): Promise<LogChannel[]> {
        return this.http.json("/api/channels", { signal });
    }

    getMembers(ids: EntityId[], signal?: AbortSignal): Promise<LogUser[]> {
        return this.http.json("/api/members", {
            headers: {
                "content-type": "application/json",
            },
            method  : "POST",
            signal,
            body    : ids,
        });
    }

    searchUsers(query: string, signal?: AbortSignal): Promise<LogUser[]> {
        return this.http.json(`/api/search-users?q=${encodeURIComponent(query)}`, { signal });
    }

    searchMembers(filters: MemberSearchRequest, signal?: AbortSignal): Promise<MemberSearchResponse> {
        return this.http.json("/api/members/search", {
            headers: {
                "content-type": "application/json",
            },
            method  : "POST",
            signal,
            body    : filters,
        });
    }
}

export const DefaultEntityClient = new EntityClient();

export type MemberSearchRequest = {
    query?: string;
    bot?: boolean | null;
    roleIds?: EntityId[];
    excludedRoleIds?: EntityId[];
    roleMode?: "any" | "all";
    limit?: number;
};

export type MemberSearchResponse = {
    total: number;
    members: LogUser[];
};
